import { combineReducers } from 'redux'
import newLink from './newLink'
import cancelLink from './cancelLink'
import customPayment from './customPayment'

const payment = combineReducers({
  newLink,
  cancelLink,
  customPayment,
})

export default payment

// Old Data in reducer
// import {
//   GENERATE_BILL_REQUEST,
//   GENERATE_BILL_SUCCESS,
//   GENERATE_BILL_FAILURE,
//   SEND_LOCATOR_MESSAGE_REQUEST,
//   SEND_LOCATOR_MESSAGE_SUCCESS,
//   SEND_LOCATOR_MESSAGE_FAILURE,
//   RESET_PAYMENT_PLUGIN
// } from '../../../../actions/types';

// const initialPluginsPaymentState = {
//   isGeneratingBill: false,
//   generateBillSuccess: false,
//   generateBillFailure: false,
//   generateBillError: '',

//   isSendingLocatorMessage: false,
//   sendLocatorMessageSuccess: false,
//   sendLocatorMessageFailure: false,
//   sendLocatorMessageError: '',

//   new_link: '',
//   custom_link: ''
// };

// export default function payment(state = initialPluginsPaymentState, action) {
//   switch (action.type) {

//     case GENERATE_BILL_REQUEST: {
//       const new_state = Object.assign({}, state, {
//         isGeneratingBill: true,
//         generateBillSuccess: false,
//         generateBillFailure: false,
//         generateBillError: '',
//       });
//       return new_state;
//     }
//     case GENERATE_BILL_SUCCESS: {
//       const new_state = Object.assign({}, state, {
//         isGeneratingBill: false,
//         generateBillSuccess: true,
//         generateBillFailure: false,
//         generateBillError: '',
//       });
//       return new_state;
//     }
//     case GENERATE_BILL_FAILURE: {
//       const new_state = Object.assign({}, state, {
//         isGeneratingBill: false,
//         generateBillSuccess: false,
//         generateBillFailure: true,
//         generateBillError: action.error
//       });
//       return new_state;
//     }

//     // SEND LOCATOR MESSAGE:
//     case SEND_LOCATOR_MESSAGE_REQUEST: {
//       const new_state = Object.assign({}, state, {
//         isSendingLocatorMessage: true,
//         sendLocatorMessageSuccess: false,
//         sendLocatorMessageFailure: false,
//         sendLocatorMessageError: '',
//       });
//       return new_state;
//     }
//     case SEND_LOCATOR_MESSAGE_SUCCESS: {
//       const new_state = Object.assign({}, state, {
//         isSendingLocatorMessage: false,
//         sendLocatorMessageSuccess: true,
//         sendLocatorMessageFailure: false,
//         sendLocatorMessageError: '',
//       });
//       return new_state;
//     }
//     case SEND_LOCATOR_MESSAGE_FAILURE: {
//       const new_state = Object.assign({}, state, {
//         isSendingLocatorMessage: false,
//         sendLocatorMessageSuccess: false,
//         sendLocatorMessageFailure: true,
//         sendLocatorMessageError: action.error
//       });
//       return new_state;
//     }

//     case RESET_PAYMENT_PLUGIN: {
//       let newState = Object.assign({}, state, {
//         isCreatingNewLink: false,
//         createNewLinkSuccess: false,
//         createNewLinkFailure: false,
//         createNewLinkError: '',

//         isCancelingLink: false,
//         cancelLinkSuccess: false,
//         cancelLinkFailure: false,
//         cancelLinkError: '',

//         isCustomPayment: false,
//         customPaymentSuccess: false,
//         customPaymentFailure: false,
//         customPaymentError: '',

//         isGeneratingBill: false,
//         generateBillSuccess: false,
//         generateBillFailure: false,
//         generateBillError: '',

//         isSendingLocatorMessage: false,
//         sendLocatorMessageSuccess: false,
//         sendLocatorMessageFailure: false,
//         sendLocatorMessageError: '',

//         new_link: '',
//         custom_link: ''
//       });
//       return newState;
//     }
//     default: {
//       return state;
//     }
//   }
// }
